import { z } from "zod";

export const SearchSchema = z.object({
  tab: z.enum(["active", "archive"]).optional(),
  operationPackageId: z.string().optional(),
  operationPackagePatternId: z.string().optional(),
});
